import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _isNil from "lodash/isNil";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es6.function.name.js";
import endUserMessages from 'utils/endUserMessages';
import { SAMPLES_UPDATE, SAMPLES_SAVING, SAMPLES_SAVED, SAMPLES_ERROR } from 'redux/actionTypes/samples';
import handleError from 'utils/http/handleError';
import fetchAPI from 'utils/http/fetchAPI';
import { loadBackendStatus } from '../backendStatus';
var updateSample = function updateSample(sampleUuid, diff) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState) {
      var experimentId, url, body, _errorMessage;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // In api v2 experimentId and experimentId are the same
              experimentId = getState().samples[sampleUuid].experimentId;
              if (!(_isNil(diff.name) || diff.option || diff.metadata)) {
                _context.next = 3;
                break;
              }
              throw new Error('This action can be used to update only the name in sample');
            case 3:
              url = "/v2/experiments/".concat(experimentId, "/samples/").concat(sampleUuid);
              body = diff;
              dispatch({
                type: SAMPLES_SAVING,
                payload: {
                  message: endUserMessages.SAVING_SAMPLE
                }
              });
              _context.prev = 6;
              _context.next = 9;
              return fetchAPI(url, {
                method: 'PATCH',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(body)
              });
            case 9:
              dispatch({
                type: SAMPLES_SAVED
              });
              dispatch({
                type: SAMPLES_UPDATE,
                payload: {
                  sampleUuid: sampleUuid,
                  sample: diff
                }
              });
              _context.next = 13;
              return dispatch(loadBackendStatus(experimentId));
            case 13:
              _context.next = 19;
              break;
            case 15:
              _context.prev = 15;
              _context.t0 = _context["catch"](6);
              _errorMessage = handleError(_context.t0, endUserMessages.ERROR_SAVING);
              dispatch({
                type: SAMPLES_ERROR,
                payload: {
                  error: _errorMessage
                }
              });
            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[6, 15]]);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};
export default updateSample;